module.exports = __webpack_public_path__ + "img/banner2.64e4c87e.jpg";